export enum GrovePath {
  Home = '/',
  Asset = '/:assetSlug',
  AssetWorkshops = '/:assetSlug/workshops',
  AssetHoneyLabel = '/:assetSlug/honey-label',
  AssetIntegrations = '/:assetSlug/integrations',
  AssetDownloads = '/:assetSlug/downloads',
  // AssetGallery = '/:assetSlug/gallery',
  AssetPreferences = '/:assetSlug/preferences',
  BeekeeperAdmin = '/admin/beekeepers',
  BouncingUsersAdmin = '/admin/bouncing-users',
  PagesAdmin = '/admin/pages',
  PagesAdminDetail = '/admin/pages/:slug',
  PageGroupsAdmin = '/admin/page-groups',
  RegionsAdmin = '/admin/regions',
  Unsubscribe = '/unsubscribe/:assetId/:email',
  Login = '/login',
  ClientHealthScore = '/admin/client-health-score',
  Reporting = '/reporting',
  AdminUserManagement = '/admin/user-management',
  AdminControlHub = '/admin/control-hub',
  BlogAutomation = '/internal-tools/blog-automation',
  PortfolioDashboard = '/portfolio-dashboard',
  AuraFreeTool = '/aura-free-tool',
  FreeToolMultiAsset = '/free-tool-multi-asset',
  KioskMode = '/:zuperJobUid/kiosk-mode',
  Signup = '/signup',
  SamlComplete = '/saml/complete',
  Bioacoustics = '/bioacoustics',
  EDNA = '/edna',
}
